export default class Course {

    constructor(
        id,
        title,
        subjects,
        examRules
    ) {
        this.id = id;
        this.title = title;
        this.subjects = subjects;
        this.examRules = examRules;

        let questions = [];

        for (let subject of this.subjects) {
            questions = questions.concat(subject.questions);
        }

        this.questions = questions;
    }

    isSingleTopic() {
        return this.subjects.length === 1 && this.subjects[0].topics.length === 1;
    }

    isPassed(totalCorrectAnswers) {
        return totalCorrectAnswers >= this.examRules.successQuestionsThreshold;
    }

    pickExamQuestions() {
        let questions = [];

        for (let subjectQuestions of this.examRules.questions) {
            if (!subjectQuestions.subject) {
                const shuffled = this.questions.sort(() => 0.5 - Math.random());
                questions = questions.concat(shuffled.slice(0, subjectQuestions.questions));
            }
            else {
                let subject = this.subjects.find(
                    ({ title }) => title === subjectQuestions.subject
                );

                if (!subject) {
                    console.log('Subject not found ' + subjectQuestions.subject);
                    continue;
                }

                const shuffled = subject.questions.sort(() => 0.5 - Math.random());
                questions = questions.concat(shuffled.slice(0, subjectQuestions.questions))
            }
        }

        questions.forEach(
            question => {
                question.answers = question.answers.slice().sort(() => 0.5 - Math.random());
            }
        );

        questions = questions.slice().sort(() => 0.5 - Math.random());

        return questions;
    }

    findTopic(id) {
        for (let subject of this.subjects) {
            let topic = subject.findTopic(id);

            if (topic) {
                return topic;
            }
        }

        return null;
    }

    findSubject(id) {
        return this.subjects.find(subject => subject.id === id);
    }

    getQuestionsByTopicIds(topicIds) {
        if (!topicIds.length) {
            return this.questions;
        }

        let questions = [];

        for (let subject of this.subjects) {

            for (let topicId of topicIds) {
                let topic = subject.findTopic(topicId);

                if (topic) {
                    questions = questions.concat(topic.questions);
                }
            }
        }

        return questions;
    }

}